<template>
    <div id="coll">
        <Breadcrumb></Breadcrumb>
        <div class="form-body">
            <el-form  :model="queryParams" label-width="80px" style="padding: 0 5px">
                <el-form-item label="店铺名称">
                    <el-radio-group v-model="queryParams.shopId" class="hide_input" @change="clickShopName">
                        <el-radio label="all">全部</el-radio>
                        <el-radio v-for="(item,index) in dpList" :label="item.shopId">{{item.shopName}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="border-top: 2px dashed #afafaf;padding-top: 5px;">
                    <el-form-item label="搜索类型">
                        <el-radio-group v-model="queryParams.searchType" size="small" class="hide_input">
                            <el-radio :label="1">标题</el-radio>
                            <el-radio :label="2">SKU</el-radio>
                            <el-radio :label="3">Parent SKU</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="搜索内容">
                        <el-input size="small" v-model="queryParams.searchStr" style="width: 30%;border: 0px;" placeholder="请输入内容"></el-input>
                        <el-button size="small" type="primary" @click="search" style="margin-left: 10px">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div style="padding-bottom: 10px;display: inline-block;width: 100%">
            <div style="float: left">
                <el-dropdown  @command="batchHandle">
                    <el-button type="primary" size="small">批量操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">批量取消定时</el-dropdown-item>
                        <el-dropdown-item command="2">批量删除</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!--<el-dropdown placement="bottom-start" trigger="click" ref="xxx">-->
                    <!--<el-button size="small" type="primary" style="margin-left: 10px">移动分类<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></el-button>-->
                    <!--<el-dropdown-menu slot="dropdown">-->
                        <!--<div class="scro">-->
                            <!--<el-scrollbar style="height: 200px">-->
                                <!--<el-tree style="text-align: center;margin-right: 15px" :data="ydlfTree.treeData" :props="ydlfTree.treeDefaultProps"-->
                                         <!--@node-click="handleNodeClick" :default-expand-all="true" :expand-on-click-node="false"></el-tree>-->
                            <!--</el-scrollbar>-->
                        <!--</div>-->
                    <!--</el-dropdown-menu>-->
                <!--</el-dropdown>-->
            </div>
            <div style="float: right">

            </div>
        </div>
        <div>
            <el-table id="outTable" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                      :span-method="arraySpanMethod"  @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="mainPic" label="图片" width="95" align="center">
                    <template scope="scope">
                        <div>
                            <div class="imgInDiv">
                                <div class="borderDiv">
                                    <img class="imgCls" :src="scope.row.mainPic"/>
                                    <div class="pz_o">
                                        <div class="pz_po">
                                            <div class="pz_at">
                                                <a>添加来源</a>
                                            </div>
                                            <div class="pz_img_o" style="width: 300px;height: 300px;">
                                                <img class="outImg" :src="scope.row.mainPic">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ly">
                                <el-link type="primary" :href="scope.row.dataUrl"  >{{scope.row.dataSource}}</el-link>
                            </div>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column prop="proTitle" label="标题/产品ID" width="300">
                    <template slot-scope="scope">
                        <el-row style="text-align: center">{{scope.row.proTitle}}</el-row>
                        <div style="padding-left: 20px;margin-top: 20px">
                            <el-row style="color: #8a8a8a">店铺[{{scope.row.shopName}}]</el-row>
                            <el-row>备注:{{scope.row.remark}}</el-row>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="htmlCode"  label="SKU" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.htmlCode"></div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center"></el-table-column>
                <el-table-column label="促销价" align="center"></el-table-column>
                <el-table-column label="库存" align="center"></el-table-column>
                <el-table-column prop="createTime" label="时间" align="center" width="200">
                    <template slot-scope="scope">
                        <el-row>创建:</el-row>
                        <el-row>{{scope.row.createTime}}</el-row>
                        <el-row>更新:</el-row>
                        <el-row>{{scope.row.updateTime}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="cancelTimed(scope.row.pId)">取消定时</el-button><br/>
                        <el-button  type="text" size="mini" @click="addRemark(scope.row)">添加备注</el-button><br/>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </div>
        <!--添加备注-->
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="noteDialogVisible" class="note-dialog">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input v-model="form.remark"  placeholder="请输入介绍信息" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="noteDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark(form.remark)" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {loadData,updateShopee,batchdeleteShopee,singledeleteShopee,batchUpdateByID,updateShopeeRemark,cancelTimed} from '@/api/product/shopee/shopee'
    import ElRow from "element-ui/packages/row/src/row";
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {getShopByPlatCode} from '@/api/product/common';
    import {getTree} from '@/api/tree/tree';
    export default {
        components: {ElRow,Breadcrumb},
        name: "CollectionBox",
        data() {
            return {
                // 总条数
                total: 0,
                // 查询参数
                queryParams:{
                    pageNum: 1,
                    pageSize: 10,
                    dataSource:'',//数据来源
                    pubStatus:'03',  //商品状态 01是采集箱
                    searchStr: null, //搜索内容
                    searchType: 1,//搜索类型
                    shopId:'all', //店铺
                },
                currentPage: 1,
                form: {
                    pId:null,
                    remark:'',
                },
                dpList: [],
                tableData: [],
                spanArr: [],
                innerTableData:[],
                innerData: [],
                ydlfTree:{
                    treeData: [],
                    treeDefaultProps: {
                        children: 'children',
                        label: 'label',
                        value:'value',
                        pCatId:'pCatId'
                    },
                },
                noteDialogVisible:false,//备注弹框
                ids:[], //选中的ID
                shopeeList:[], //批量对象
                platCode:[],//平台的字典CODE

            }
        },
        created() {
            var that = this
            that.getDicts("s_plat_code").then(response => {
                that.platCode = response.data;
            });
            that.getList();
            that.getPlatList(that);
            that.getMoveClassification(that);
        },
        methods: {
            getList(){
                this.loading = true;
                //当前登录的人
                this.queryParams['operNo']=this.$store.state.user.name
                loadData(this.queryParams).then((res) => {
                    this.tableData = res.rows;
                    this.total = res.total;

                    this.loading = false;
                    for (let key in this.tableData) {
                        if (this.tableData[key].dataSource!=null){
                            for (var i=0;i < this.platCode.length;i++) {
                                if (this.tableData[key].dataSource == this.platCode[i].dictValue){
                                    this.$set(this.tableData[key],'dataSource', this.platCode[i].dictLabel);
                                    let tableData = this.tableData;
                                    break;
                                }
                            }
                        }
                        //SKU集合赋值
                        let innerData = this.tableData[key].sShopeeSkuList;
                        this.innerData= innerData;
                        this.Generationhtml(key);
                    }
                })
            },
            //添加备注方法
            addRemark(row){
                for (let key in this.form) {
                    this.form[key]=null;
                }
                this.noteDialogVisible=true;
                this.form.remark=row.remark;
                this.form.pId=row.pId;
            },
            //提交备注
            submitRemark(remark){
                updateShopeeRemark(this.form).then((res) => {
                    if (res.code === 200) {
                        this.msgSuccess("修改成功");
                        this.getList();
                        this.noteDialogVisible = false;
                    }
                })
            },
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
            show: function() {

            },
            search: function() {
                this.getList()
            },
            //批量操作
            batchHandle: function(val) {
                if ("1" == val) {
                    // this.batchUpdate();
                    this.batchCancelTimed();
                } else {
                    this.batchDelete();
                }
            },
            //批量移入待发布
            batchUpdate() {
                const shopeeList = this.shopeeList;
                if (this.shopeeList.length==0){
                    this.msgError("批量待发布至少选择一条数据");
                    return
                }
                this.$confirm('是否确认把这' + this.shopeeList.length + '条数据项批量移入待发布', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    shopeeList.forEach((item) => {
                        //往对象添加新字段
                        item['pubStatus']='02'
                    });
                    return batchUpdateByID(JSON.stringify(shopeeList));
                }).then(() => {
                    this.getList();
                    this.msgSuccess("修改成功");
                }).catch(function() {});
            },
            //批量删除
            batchDelete() {
                const ids =this.ids;
                if (this.ids.length == 0){
                    this.msgError("请选择要删除的产品");
                    return;
                }
                this.$confirm('是否确认删除选择的' + this.ids.length + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchdeleteShopee(ids);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //用户勾选
            handleSelectionChange(val) {
                this.ids=[];
                this.shopeeList=[];
                //获取当前用户
                var userName = this.$store.state.user.name;
                val.forEach((item) => {
                    //批量移入待发布
                    var updateStatePara={
                        "pId":item.pId,
                        "operNo":userName,
                    };
                    this.ids.push(item.pId);
                    this.shopeeList.push(updateStatePara);

                });
            },
            //合并列
            arraySpanMethod: function({row,column,rowIndex,columnIndex}) {
                if (columnIndex === 3) {
                    return [1, 4];
                }else if(columnIndex === 4 || columnIndex === 5 ||columnIndex === 6){
                    //将合并后的第四、五、六列单元格清除掉，不然后面的单元格会后移
                    return [0, 0];
                }
            },
            getSpanArr(data) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                        if (data[i]["id"] === data[i - 1]["id"]) {
                            this.spanArr[this.pos] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            move(row) {
                this.$confirm('确定要 [移入到待发布吗]?', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return updateShopee(row.pId);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("移入待发布成功");
                }).catch(function() {});
            },
            edit(row) {
                //编辑产品
                this.$router.push({path:"/product/shopee/edit",query:{pId:row.pId}})
            },
            addNote: function() {

            },
            deleteRow(row) {
                let pId = row.pId;
                this.$confirm('是否确认删除shopee产品标题为'+pId+'的数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return singledeleteShopee(row.pId);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //点击移入分类的tree
            handleNodeClick(val) {
                if (this.ids.length == 0){
                    this.msgError("请选择需要移动分类的商品");
                    //点击后消失,防止多次点击
                    this.$refs.xxx.visible =false
                    return
                }
                let shopeeList = this.shopeeList;
                this.$confirm('是否确认把这' + this.ids.length + '条数据项批量移入分类--><span style="color: red">'+val.label+'</span>吗?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    shopeeList.forEach((item) => {
                        //往对象添加新字段
                        item['typeNo']=val.value
                    });
                    return batchUpdateByID(JSON.stringify(shopeeList));
                }).then(() => {
                    this.getList();
                    this.msgSuccess("修改成功");
                }).catch(function() {});
                //点击后消失,防止多次点击
                this.$refs.xxx.visible =false
            },
            //生成表格HTML
            Generationhtml(key){
                // 控制单独的class
                var className = key;
                var tabHtml ='<table class="innerTab" style="width: 100%">'
                this.innerData.forEach((item,index)=>{
                    //转空字符
                    if (item.skuno==null){
                        item.skuno='';
                    }
                    if (item.price==null){
                        item.price='';
                    }
                    if (item.promPrice==null){
                        item.promPrice='';
                    }
                    if (item.invent==null){
                        item.invent='';
                    }
                    if(index < 5){
                        tabHtml += `<tr>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.promPrice +`</td>
					<td >`+item.invent +`</td>

				</tr>`;
                    }else{
                        tabHtml += `<tr  style="display: none" class=${className}>
					<td >`+item.skuno +`</td>
					<td >`+item.price +`</td>
					<td >`+item.promPrice +`</td>
					<td >`+item.invent +`</td>
				</tr>`;
                    }

                });
                if(this.innerData.length > 5){
                    tabHtml += `</table><el-row class="tab_butt"><div id="row_bt" onclick="explanRow(${className})">展开<i class="el-icon-caret-bottom"></i></div></el-row>`;
                }else{
                    tabHtml += `</table>`;
                }
                this.tableData[key].htmlCode = tabHtml;
                window.explanRow = function (val) {
                    var flag = $("."+val).is(":hidden");
                    if(flag){
                        $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
                        $("."+val).show();
                    }else{
                        $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
                        $("."+val).hide();
                    }
                }
            },
            //获取店铺集合
            getPlatList(that){
                //获取当前用户
                var userName = this.$store.state.user.name;
                var params='05';
                //获取店铺集合
                getShopByPlatCode(params).then((res) => {
                    that.dpList=res.data;
                })
            },
            //移动分类树形数据
            getMoveClassification(that){
                getTree().then((res) => {
                    this.ydlfTree.treeData=res.data;
                })
            },
            //店铺查询
            clickShopName(val){
                this.queryParams.searchStr=null;
                this.getList();
            },
            //根据选择的搜索类型进行查询
            getListBySearchType(){
                let searchType = this.queryParams.searchType;
                let searchStr = this.queryParams.searchStr;

            },
            //取消定时
            cancelTimed(pId){
                var data = {
                    'pIds':pId
                }
                cancelTimed(data).then((res) => {
                    this.getList();
                    this.msgSuccess("取消定时成功")
                })
            },
            //批量取消定时
            batchCancelTimed(pId){
                var size = this.ids.length;
                if (size<=0){
                    this.msgError("请选择要取消定时的数据");
                    return
                }
                var ids = this.ids;
                var join = ids.join("-");
                var data = {
                    'pIds':join
                }
                this.$confirm('是否确认取消选中的'+size+'条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return  cancelTimed(data);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("取消定时成功")
                }).catch(function() {});
            }

        },
        mounted() {
            this.getSpanArr(this.tableData);
        }
    }
</script>

<style>
</style>
<style scoped>
    @import '../../../assets/css/Shopee.css';
    /* >>> 是深度选择器,不会影响全局*/
    .scro >>> .el-scrollbar__wrap {
        overflow-x: hidden;
    }
</style>

